import { form } from '../../formState'
import { useTexts } from './useTexts'

export function TimeWindows() {
  const texts = useTexts()

  return (
    <form.TimeWindowField
      name="timeWindows"
      timeWindowProps={{ testId: 'timeWindows', label: texts.timeWindows }}
    />
  )
}
